<fd-popover #goToPathPopover
  [focusTrapped]="true"
  [focusAutoCapture]="true"
  [(isOpen)]="isGoToPathPopoverOpen"
  (isOpenChange)="onOpenChange()"
  [closeOnOutsideClick]="true">
  <fd-popover-control>
    <button fd-button
      id="go-to-path-btn"
      label="Go"
      i18n-label="XBUT|Go button for open Go To Path Popover@@goToPath.openButton"
      [fdMenu]="true"
      [fdCompact]="true"
      [fdType]="'emphasized'"
      title="Go to Path"
      i18n-title="XTOL|Tooltip of the Go button@@goActionButtonTooltip">
    </button>
  </fd-popover-control>
  <fd-popover-body class="go-to-path">
    <div class="cell-popover">
      <div fd-popover-body-header>
        <div fd-bar id="popover-bar-header-go-to-path">
          <div fd-bar-left>
            <fd-bar-element class="header-title" i18n-title="XTIT|Title of the Go To Path Popover@@goToPath.popoverTitle">Go to Path</fd-bar-element>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper" >
      <fd-busy-indicator [block]="true" size="l" [loading]="busy"
        ariaLabel="loading">
      </fd-busy-indicator>
      <div [style.visibility]="busy ? 'hidden' : 'visible'">
        <form (ngSubmit)="go(trimmedPath())">
          <div fd-form-item>
            <app-helpful-label for="inputPath"
              i18n-label="XFLD|Field Name input@@goToPath.inputLabel"
              i18n-popoverTitle="Popover title|Title of the input path@@goToPath.input"
              label="Path"
              popoverTitle="Go to Path" [popoverBody]="goToPathInfoHelp">
            </app-helpful-label>
            <ng-template #goToPathInfoHelp>
              To navigate quickly in Unified Services Workspace, you can enter the path of any organization, folder, or resource group, or you can choose a recently visited path.<br/><br/>
              Example: /sample-organization/my-folder <br/><br/>
              Currently, you cannot enter a path that navigates directly to other types of resources, such as roles, secrets, or managed services.
            </ng-template>
            <div class="goToPathInput">
              <input fd-form-control
                id="inputPath"
                type="text"
                placeholder="Enter a path"
                i18n="XMSG|Placeholder text for the input path@@goToPath.input"
                [(ngModel)]="pathSignal"
                autocomplete="off"
                [ngModelOptions]="{standalone: true}"/>
              <button fd-button
                class="uppercase-btn"
                id="popover-go-btn"
                i18n-label="XBUT|Go button for the Go To Path Popover@@goToPath.goToPathButton"
                label="Go"
                [fdCompact]="true"
                fdType="emphasized"
                [disabled]="busy || !trimmedPath()"
                (click)="go(trimmedPath())">
              </button>
            </div>
          </div>
          <button type="submit" hidden></button>
        </form>
        <app-recent-list #recentListComponent class="recent-list" [path]="trimmedPath()" [pathEnteredEvent]="pathEnteredEvent.asObservable()" (recentItemClicked)="onRecentItemClicked($event)"></app-recent-list>
      </div>
      @if (!!error) {
        <app-error-strip [errorText]="error"></app-error-strip>
      }
    </div>
    <div fd-popover-body-footer>
      <div fd-bar barDesign="footer">
        <div fd-bar-right>
          <fd-button-bar
            class="uppercase-btn"
            i18n-label="XBUT|Cancel button for the Go To Path Popover@@goToPath.cancelButton"
            label="Cancel"
            [fdCompact]="true"
            fdType="transparent"
            [disabled]="busy"
            (click)="onCancel()">
          </fd-button-bar>
        </div>
      </div>
    </div>
  </fd-popover-body>
</fd-popover>
